<div class="svg-container">

    @if (isAvailable()) {
        <app-navigation-button
            [config]="config()"
            class="navigation-button">
            <app-icon [type]="config().buildingType" />
        </app-navigation-button>
    }

    <svg
        [class]="'animated-svg ' +  config().class"
        [attr.viewBox]="'0 0 ' + config().width + ' ' + (height() + config().heightOffset)"
        preserveAspectRatio="xMidYMin meet">
  
        <g [attr.transform]="'translate(0, ' + (height()- config().finalHeight) +')'" app-shadow [height]="height()" [type]="config().buildingType"/>

        <g
            app-wall
            [type]="config().buildingType"
            [height]="height()"></g>

        @switch (config().buildingType) {
            @case (buildingType.Catalog) {
                <g
                    app-catalog-roof
                    [type]="config().buildingType" />
                <g
                    app-catalog-window
                    [finalHeight]="config().finalHeight"
                    [height]="height()" />
            }

            @case (buildingType.Warehouse) {
                <g
                    app-warehouse-roof
                    [type]="config().buildingType" />
                <g
                    app-warehouse-window
                    [type]="config().buildingType"
                    [windowMargin]="config().windowMargin"
                    [height]="height()" />
            }

            @case (buildingType.Marketplace) {
                <g
                    app-marketplace-roof
                    [type]="config().buildingType" />
                <g
                    app-warehouse-window
                    [type]="config().buildingType"
                    [windowMargin]="config().windowMargin"
                    [height]="height()" />
            }

            @case (buildingType.SpaceConfig) {
                <g
                    app-space-config-roof
                    [type]="config().buildingType" />
                <g
                    app-space-config-window
                    [height]="height()" />
            }

            @case (buildingType.Monitoring_Reporting) {
                <g
                    app-monitor-roof
                    [type]="config().buildingType" />
                <g
                    app-monitor-window
                    [height]="height()" />
            }

            @case (buildingType.Tracker) {
                <g
                    app-totalizer-roof
                    [type]="config().buildingType" />
                <g
                    app-totalizer-window
                    [height]="height()" />
            }

            @case (buildingType.Management) {
                <g
                    app-management-roof
                    [type]="config().buildingType" />
                <g
                    app-management-window
                    [height]="height()" />
            }

            @case (buildingType.Dummy) {
                <g
                    app-dummy-roof
                    [type]="config().buildingType" />
                <g
                    app-dummy-window
                    [height]="height()" />
            }

            @case (buildingType.Library) {
                <g
                    app-library-roof
                    [type]="config().buildingType" />
                <g
                    app-library-window
                    [height]="height()" />
            }
        }

        <g app-border />

        @if (config().showBase) {
            <g [attr.transform]="'translate(0, ' + (height()- config().finalHeight) +')'"
                app-base
                [height]="height()"
                [type]="config().buildingType" />
        }
    </svg>
</div>
